import { createWebHistory, createRouter } from 'vue-router';
import routes from './routes';
import { partnerAppGate } from './middleware';
import { useHeader, useNavbar } from '@/utils/composables';
import { clearTerminalLocale } from '@/utils/plugins/i18n/terminal-locale';

const FAILED_IMPORT_ERROR = 'Failed to fetch dynamically imported module';
const SCRIPT_FAILED_ERROR = 'Importing a module script failed';

const router = createRouter({
	history: createWebHistory(),
	base: import.meta.env.VITE_API_PROXY,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return Promise.resolve(savedPosition || { x: 0, y: 0 });
	}
});

router.onError((error, to) => {
	if (
		error.message.includes(FAILED_IMPORT_ERROR) ||
		error.message.includes(SCRIPT_FAILED_ERROR)
	) {
		if (to && to.fullPath) {
			window.location = to.fullPath;
		} else {
			window.location.reload();
		}
	}
});

router.afterEach((to, from) => {
	// Гейт партнёрского приложения по бренду филиала (DDR-259): решение по
	// странице, на которую гость реально попал; переход не блокируем
	partnerAppGate(to);

	if (to.name !== from.name) {
		const { setNavbarVisibility } = useNavbar();
		const { setBalanceVisibility } = useHeader();
		setNavbarVisibility(!!to.meta.isNavbarActive);
		setBalanceVisibility(!!to.meta.isBalanceVisible);
	}

	// вне контекста филиала действует страновой набор языков
	if (!to.params.filial_id) {
		clearTerminalLocale();
	}
});

export default router;
